export default "__VITE_ASSET__DTaRs7ZB__"